import { readonly, reactive } from 'vue'

const pending = reactive<Record<string, number>>({})

export function useWait() {
  return {
    progress: readonly(pending),
    start(key: string) {
      pending[key] = (pending[key] ?? 0) + 1
    },
    end(key: string) {
      const next = (pending[key] ?? 1) - 1
      if (next > 0) pending[key] = next
      else delete pending[key]
    },
    is(key: string) {
      return (pending[key] ?? 0) > 0
    },
    any() {
      return Object.keys(pending).length > 0
    },
  }
}
